// extracted by mini-css-extract-plugin
module.exports = {"input":"wasteBill_input__DAgl6","label":"wasteBill_label__8hj7X","btn":"wasteBill_btn__2Urz0","input1":"wasteBill_input1__1PtPR"};